import { render, staticRenderFns } from "./InstructorSessionForm.vue?vue&type=template&id=265753b2&scoped=true"
import script from "./InstructorSessionForm.vue?vue&type=script&lang=js"
export * from "./InstructorSessionForm.vue?vue&type=script&lang=js"
import style0 from "./InstructorSessionForm.vue?vue&type=style&index=0&id=265753b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265753b2",
  null
  
)

export default component.exports